import React, { useState } from 'react';
import closeIcon from '../assets/images/Close.svg'; 

// Lightbox Component
const Lightbox = ({ image, onClose }) => {
  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <img src={image} alt="Lightbox" />
        <button className="lightbox-close" onClick={onClose}>
          <img src={closeIcon} alt="Close" />
        </button>
      </div>
    </div>
  );
};

const CustomSliderWithoutLogin = ({ media }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % media.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + media.length) % media.length);
  };

  const hasMultipleItems = media.length > 1;

  const openLightbox = (imageUrl) => {
    console.log('Opening lightbox with image:', imageUrl); // Debugging
    setSelectedImage(imageUrl);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    console.log('Closing lightbox'); // Debugging
    setLightboxOpen(false);
    setSelectedImage('');
  };

  return (
    <div className="custom-slider without_login_wrap">
      {hasMultipleItems && (
        <button className="arrow left-arrow" onClick={prevSlide}>
          &lt;
        </button>
      )}
      <div className="slider-content">

        <div
        className="slider-content-image"
        style={{
          backgroundImage: media[currentIndex].isVideo ? 'none' : `url(${media[currentIndex].url})`,
        }}
      >
      </div>

        {media.length > 0 && (
          <>
            {media[currentIndex].isVideo ? (
              <video controls>
                <source src={media[currentIndex].url} />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={media[currentIndex].url}
                alt="Post Media"
                onClick={() => openLightbox(media[currentIndex].url)}
              />
            )}
          </>
        )}
      </div>
      {hasMultipleItems && (
        <button className="arrow right-arrow" onClick={nextSlide}>
          &gt;
        </button>
      )}
      {lightboxOpen && (
        <Lightbox image={selectedImage} onClose={closeLightbox} />
      )}
    </div>
  );
};

export default CustomSliderWithoutLogin;
